'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var effects = require('@redux-saga/core/effects');



Object.keys(effects).forEach(function (key) { exports[key] = effects[key]; });



//////////////////
// WEBPACK FOOTER
// ./~/redux-saga/dist/redux-saga-effects-npm-proxy.cjs.js
// module id = 14
// module chunks = 39